export default __webpack_public_path__ + "static/media/20w50.4523e2b1.png";